import React, { Component } from 'react';
import "./Resume.css";

class Clemson extends Component {
   render() {
      return (
         <div className="Clemson">
               <h2 className="text-center section-heading">MSCS Clemson University 8/97 - 12/00</h2>
               <hr/>
               <p><strong>GPA:4.0/4.0</strong></p>
               <p>My studies for the Master's Degree in Computer Science 
                  concentrated on Object Oriented Programming in C++, 
                  software testing methodologies, and IP computer 
                  networking protocols.</p>

         </div> // End of <div className="Clemson">
      );
   }
}

export default Clemson;





// WEBPACK FOOTER //
// ./src/components/Resume/Clemson.js